// extracted by mini-css-extract-plugin
export default {"tasks":"BO-z","task":"CO-z","svg":"DO-z","text":"EO-z"};